import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { BereichId, VERWALTUNG_BEREICHE, VerwaltungBadge } from './verwaltung-bereiche';

@Component({
  selector: 'app-verwaltung-nav',
  standalone: true,
  imports: [MatIconModule, TranslatePipe],
  templateUrl: './verwaltung-nav.component.html',
  styleUrl: './verwaltung-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerwaltungNavComponent {
  readonly gruppen = inject(VERWALTUNG_BEREICHE);

  readonly aktiv = input.required<BereichId>();
  readonly firmenname = input.required<string>();
  readonly eingeladen = input.required<number | null>();
  readonly rechnerOffline = input.required<number | null>();
  readonly waehlen = output<BereichId>();

  anzahl(badge: VerwaltungBadge | null): number {
    if (badge === 'eingeladen') return this.eingeladen() ?? 0;
    if (badge === 'rechnerOffline') return this.rechnerOffline() ?? 0;
    return 0;
  }

  badgeText(badge: VerwaltungBadge, n: number): string {
    return `verwaltung.badge.${badge}${n === 1 ? 'Eins' : ''}`;
  }
}
